import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../../_customComponent/Icons/_svg/app-jt-svg-icon.module';
import { PasswordInputComponent } from './password-input.component';

@NgModule({
  declarations: [PasswordInputComponent],
  imports: [CommonModule, SvgIconModule],
  exports: [PasswordInputComponent]
})
export class PasswordInputModule { }
